/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InvestmentFund } from './InvestmentFund';
import {
    InvestmentFundFromJSON,
    InvestmentFundFromJSONTyped,
    InvestmentFundToJSON,
} from './InvestmentFund';

/**
 * 
 * @export
 * @interface InvestmentPlan
 */
export interface InvestmentPlan {
    /**
     * 
     * @type {string}
     * @memberof InvestmentPlan
     */
    investmentPlanNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentPlan
     */
    investmentPlanName: string;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentPlan
     */
    inceptionDate: Date;
    /**
     * 
     * @type {Array<InvestmentFund>}
     * @memberof InvestmentPlan
     */
    investmentFunds: Array<InvestmentFund>;
    /**
     * 
     * @type {number}
     * @memberof InvestmentPlan
     */
    portfolioPercentage: number;
}

/**
 * Check if a given object implements the InvestmentPlan interface.
 */
export function instanceOfInvestmentPlan(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentPlanNumber" in value;
    isInstance = isInstance && "investmentPlanName" in value;
    isInstance = isInstance && "inceptionDate" in value;
    isInstance = isInstance && "investmentFunds" in value;
    isInstance = isInstance && "portfolioPercentage" in value;

    return isInstance;
}

export function InvestmentPlanFromJSON(json: any): InvestmentPlan {
    return InvestmentPlanFromJSONTyped(json, false);
}

export function InvestmentPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentPlan {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentPlanNumber': json['InvestmentPlanNumber'],
        'investmentPlanName': json['InvestmentPlanName'],
        'inceptionDate': (new Date(json['InceptionDate'])),
        'investmentFunds': ((json['InvestmentFunds'] as Array<any>).map(InvestmentFundFromJSON)),
        'portfolioPercentage': json['PortfolioPercentage'],
    };
}

export function InvestmentPlanToJSON(value?: InvestmentPlan | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentPlanNumber': value.investmentPlanNumber,
        'InvestmentPlanName': value.investmentPlanName,
        'InceptionDate': (value.inceptionDate.toISOString()),
        'InvestmentFunds': ((value.investmentFunds as Array<any>).map(InvestmentFundToJSON)),
        'PortfolioPercentage': value.portfolioPercentage,
    };
}

